import messages_zh_TW from '../../resources/i18n/messages_zh_TW';
import messages_en from '../../resources/i18n/messages_en';

export const INIT_I18N_SUCCESS = 'INIT_I18N_SUCCESS';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const WAIT_INIT_LOCALE = 'WAIT_INIT_LOCALE';

export const initI18n = (locale) => (dispatch) => {
    let changeLocale = 'en';
    if (locale) {
        changeLocale = locale;
    }

    let localeMessage = null;
    switch (changeLocale) {
        case 'zh-TW':
            localeMessage = messages_zh_TW;
            break;
        default:
            localeMessage = messages_en;
    }

    dispatch({
        type: INIT_I18N_SUCCESS,
        i18nParams: {
            locale: changeLocale,
            localeMessage: localeMessage
        }
    });
};